__turbopack_context__.v({
  "quiz-tab-item": "quiz-tab-item-module-scss-module__6I_v-W__quiz-tab-item",
  "quiz-tab-item--focus-visible": "quiz-tab-item-module-scss-module__6I_v-W__quiz-tab-item--focus-visible",
});
